<template>
    <reum-header></reum-header>
    <div class="contents">
        <router-view/>
    </div>
</template>

<script>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import ReumHeader from './components/ReumLib/layout/ReumHeader.vue'
// import { useToast } from 'vue-toastification'

export default {
    name: 'app',
    components: {
        ReumHeader
    },
    setup() {
        // const toast = useToast()
        const store = useStore()
        const router = useRouter()
        const route = useRoute()

        onMounted(() => {
            // Mounted
            store.dispatch('doReadStateFromStorage')

            setTimeout(() => {
                console.log(route.path, route.path.indexOf('Scripts'))
                if( route.path !== '/outlogin' && route.path.indexOf('Scripts') < 0 ){

                    if( route.path.indexOf([ '/Front/List', '/Front/Login' ]) 
                        || route.path.indexOf('/Front/View') >= 0 
                    ) {
                        if( ( route.path.indexOf([ '/Front/List' ]) >= 0 || route.path.indexOf('/Front/View') >= 0 )
                            && store.state.user.uid == '' 
                        ) {
                            alert("Please, Login.")
                            router.push({ path:'/Front/Login', params:{} })
                        }
                    } else {
                        if (store.state.user.idx <= 0) {
                            alert("Login info expired.")
                            router.back()
                            // window.location.href = '';
                        }
                    }
                }
            }, 300)
        });

        return { };
    }
}
</script>


<style lang="scss">
@import "@/scss/reset.scss";
@import "@/scss/_variables.scss";
@keyframes circleMotion {
    0% {
        transform: scale(.85);
    }
    30% {
        transform: scale(.85);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes innerCircleMotion {
    0% {
        transform: scale(.85);
    }
    70% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes outlineMotion {
    0% {
        border-width: 15px;
    }
    40% {
        border-width: 20px;
    }
    100% {
        border-width: 20px;
    }
}
@keyframes fadeMotion {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes msgboxMotion {
    0% {
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    80% {
        opacity: .7;
    }
    100% {
        opacity: 0;
    }
}
@keyframes rotateMotion {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    position: absolute;
    top:0;
    bottom:0;
    right:0;
    left:0;
    

    .contents {
        position:relative; padding-top:50px;
    }
}

html,body {
    margin: 0;
    background-color: #f9f9f9;
}

.cb50 {
    height: 50px;
    clear: both;
}


.cb20 {
    height: 20px;
    clear: both;
}

.cb30 {
    height: 30px;
    clear: both;
}

.btn-full {
        height: 2.5rem;
        width: 100%;
        border-radius: 20px;
        border: 1px solid $primaryColor;
        background-color: $primaryColor;
        color: #FFF;
        font-weight: bold;
        font-size: 1.1rem;
        box-shadow: 0px 5px 15px rgba($primaryColor, 0.7);
}
</style>
